import * as React from 'react';

import { Icon } from '@blueprintjs/core';

import './TrackedProject.scss';

interface ITrackedProjectProps {
    project?: { id: number; name: string; company: string; link: string };
    navigate?: (path: string) => void;
}

const TrackedProject: React.StatelessComponent<ITrackedProjectProps> = (props) => {
    if (!props.project) {
        return (
            <div className="lh-tracked-project" style={{ borderBottom: '1px solid #ccc' }}>
                <div style={{ padding: '8px' }}>
                    <div className="bp3-skeleton" />
                </div>
            </div>
        );
    }

    const onClick = () => {
        if (props.project && props.navigate) {
            props.navigate(props.project.link);
        }
    };

    const icon: JSX.Element = <Icon icon="star" style={{ color: 'orange' }} />;

    return (
        <div className="lh-tracked-project" onClick={onClick}>
            <div className="line-1">
                {icon} {props.project.name}
            </div>
            <div className="line-2">{props.project.company}</div>
        </div>
    );
};

export default TrackedProject;



// WEBPACK FOOTER //
// ./src/components/common/TrackedProject.tsx